import { render, staticRenderFns } from "./topNew.vue?vue&type=template&id=763420ad&scoped=true"
import script from "./topNew.vue?vue&type=script&lang=js"
export * from "./topNew.vue?vue&type=script&lang=js"
import style0 from "./topNew.vue?vue&type=style&index=0&id=763420ad&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "763420ad",
  null
  
)

export default component.exports